"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var Link = styled_components_1.default(react_router_dom_1.NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #2362a2;\n  font-size: 15px;\n  font-weight: 400;\n  text-decoration: underline;\n"], ["\n  color: #2362a2;\n  font-size: 15px;\n  font-weight: 400;\n  text-decoration: underline;\n"])));
exports.default = Link;
var templateObject_1;
